import React, { useEffect, useState } from 'react';
import Api from '../../services/Api';
import StatusHelper from '../../helpers/StatusHelper';
import { useSalesHistoryConfig } from '../../hooks/SalesHistoryConfigContext';
import { useStorefrontSettings } from '../../hooks/StorefrontSettingsContext';
import Notifications from '../../services/Notifications';
import PDFIcon from '../icons/OrderAckIcon';
import WhatsAppIcon from '../icons/WhatsAppIcon';
import { GridToolbarContainer, GridToolbarFilterButton, GridToolbarExport, GridToolbarDensitySelector, GridPagination } from '@mui/x-data-grid-premium';
import Money from '../Money';
import DateDisplay from '../DateDisplay';
import DateHelper from "../../helpers/DateHelper";
import PricingHelper from '../../helpers/PricingHelper';
import TranslatableDataGridServerLoaded from '../shared/TranslatableDataGridServerLoaded';
import StorefrontAdminTheme from '../shared/MUIStyles/StorefrontAdminTheme';
import { useStorefrontAdministrationConfig } from '../../hooks/StorefrontAdministrationConfigContext';
import { Box, Stack, Typography, Chip, IconButton, Button, Divider, SwipeableDrawer, Paper, ThemeProvider, Fade } from '@mui/material';
import { Link } from 'react-router-dom';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';




const OrderLines = (props) => {
    const salesHistoryConfig = useSalesHistoryConfig();
    const localized = salesHistoryConfig.labels;
    const storefrontConfig = useStorefrontSettings();
    const dateDisplayFormat = storefrontConfig.settingsList.DateDisplayFormat;
    const gridLocalized = useStorefrontAdministrationConfig().labels;
    const [orderRows, setOrderRows] = useState([]);
    const [csvData, setCSVData] = useState([]);
    const wrapperTheme = StorefrontAdminTheme;
    
    const excludeStatuses = [
        'Shipped',
        'Complete',
        'Cancelled',
        'PartiallyShipped',
        'ReadyToInvoice',
        'Invoiced'
    ];
    const [fileExistenceData, setFileExistenceData] = useState([]);
    const [isFileCheckComplete, setIsFileCheckComplete] = useState(false);

    const [drawerOpen, setDrawerOpen] = React.useState(false);
    const [selectedRow, setSelectedRow] = React.useState(null);

    const openDrawer = (row) => {
        setSelectedRow(row);
        setDrawerOpen(true);
    };

    const closeDrawer = () => setDrawerOpen(false);

    

    useEffect(() => {
        if (props.csvOrders) {
            const formattedData = formatCSVData(props.csvOrders);
            setCSVData(formattedData);
        }

        if (props.orderLines ) {
            const orders = mapOrderlinesToOrders(props.orderLines); 
            checkOrderFileExists(orders);
        }
    }, [props.csvOrders, props.orderLines]);

    const visibleFields = ['name', 'position'];

    const customToolbar = () => {
        return (
            <GridToolbarContainer  >
                <Box sx={{ flexGrow: 1 }} />
                <GridToolbarFilterButton
                    slotProps={{
                        tooltip: { title: 'Filter list' }
                    }}
                    variant="outlined"
                    color="update"

                />
                <GridToolbarDensitySelector
                    slotProps={{
                        tooltip: { title: 'Change density' }
                    }}
                    variant="outlined"
                    color="update"
                />
                <GridToolbarExport
                    printOptions={{ disableToolbarButton: true }}
                    csvOptions={{
                        allColumns: true
                    }}
                    excelOptions={{
                        allColumns: true
                    }}
                    slotProps={{
                        tooltip: { title: 'Export data' }
                    }}
                    
                    csvOptions={{
                        allColumns: true,                 
                    }}
                    excelOptions={{
                        allColumns: true
                    }}
                    variant="outlined"
                    color="update"
                />
            </GridToolbarContainer>
        );
    }

    const mapOrderlinesToOrders = (orderLines) => {
        var rows = [];
        orderLines.forEach((orderLine, index) => {
            rows.push({
                id: index,
                orderId: orderLine.orderId,
                referenceNumber: orderLine.referenceNumber,
                orderDate: orderLine.orderDate,
                requestDate: orderLine.requestDate,
                estimatedDate: orderLine.estimatedDate,
                shipDate: orderLine.shipDate,
                productSku: orderLine.productSku,
                itemDescription: orderLine.lineDescription,
                quantity: orderLine.quantity,
                quantityBackordered: orderLine.quantityBackordered,
                unitPrice_Amount: orderLine.unitPrice_Amount,
                price_Amount: orderLine.price_Amount,
                price_Currency: orderLine.price_Currency,
                lineStatus: orderLine.lineStatus,
                invoiceNumber: orderLine.invoiceNumber,
                billToId: orderLine.billToId,
                orderType: orderLine.orderType,
                orderCompany: orderLine.orderCompany
            });
        });
        setOrderRows(rows);
        const orders = orderLines.map(orderLine => ({
            FileNumber: orderLine.orderId,
            DocumentType: orderLine.orderType,
            BillToId: orderLine.billToId,
            FileName: `${orderLine.billToId}-${orderLine.orderId}${orderLine.orderType}.pdf`
        }));
        return { FileDetails: orders };
    };

    const formatCSVData = (data) => {
        const formattedData = JSON.parse(JSON.stringify(data));
        formattedData.forEach((item) => {
            item.unitPrice_Amount = PricingHelper.formatNumber(props.selectedCustomer.address.country, item.unitPrice_Amount);
            item.price_Amount = PricingHelper.formatNumber(props.selectedCustomer.address.country, item.price_Amount);
            item.price_Currency = undefined;
            if (item.orderDate) {
                item.orderDate = DateHelper.format(item.orderDate, "yyyy-MMM-dd");
            }
            if (item.requestDate) {
                item.requestDate = DateHelper.format(item.requestDate, "yyyy-MMM-dd");
            }
            if (item.estimatedDate) {
                item.estimatedDate = DateHelper.format(item.estimatedDate, "yyyy-MMM-dd");
            }
            if (item.estimatedShipDate) {
                item.estimatedShipDate = DateHelper.format(item.estimatedShipDate, "yyyy-MMM-dd");
            }
            if (item.lineStatus) {
                item.lineStatus = StatusHelper.formatStatus(item.lineStatus, props.localized);
            }
            if (item.productDescription) {
                item.productDescription = item.productDescription.replace('"', '');
            }
        });
        return formattedData;
    };

    const checkOrderFileExists = async (mappedOrders) => {
        if (mappedOrders.FileDetails.length > 0) {
            const response = await Api.checkOrderFileExists(`/api/orders/checkOrderFileExists`, { FileDetails: mappedOrders.FileDetails });
            if (response.ok) {
                const data = await response.json();
                setFileExistenceData(data);
                setIsFileCheckComplete(true);
            }
        } else {
            setIsFileCheckComplete(true);
        }
    };

    const getPDF = (orderNumber, orderType, billToId) => {
        Api.downloadFileName(`/api/orders/GetPDF/${billToId}/${orderNumber}/${orderType}`, `${billToId}-${orderNumber}${orderType}`)
            .then(handleError);
    };

    const getPDFLink = (orderNumber, orderType, billToId) => {
        Api.fetch(`/api/orders/GetPDFShareLink/${billToId}/${orderNumber}/${orderType}`)
            .then((res) => {
                window.open(res.shareUrl, '_blank');
            });
    };

    const handleError = (res) => {
        if (!res) Notifications.error(localized.NoPDFMessage);
    };

    const listViewCell = (params) => {
        const row = params.row;
        const isThisRowOpen = drawerOpen && selectedRow?.id === row.id;
        const fileData = fileExistenceData.find(
            (file) =>
                String(file.fileNumber).trim() === String(row.orderId).trim() &&
                file.exists === true
        );
        const showIcons = !!fileData;

        const statusText = StatusHelper.formatStatus(row.lineStatus, props.localized);

        return (
            <Box sx={{ width: '100%', pt: 1, pb: 0 }}>
                <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
                    <Typography
                        variant="body1"
                        fontWeight={700}
                        component={Link}
                        to={`/order/${row.orderId}/${row.orderCompany}/${row.orderType}`}
                        style={{ textDecoration: 'none' }}
                    >
                        {row.orderId}
                    </Typography>
                    <Chip size="small" label={statusText} />
                    {props.ordersByLinePDF && (
                        <strong>
                            <div className="br-invoice-pdf d-inline-flex" style={{ fontSize: '18px' }}>
                                <div
                                    style={{
                                        cursor: showIcons ? 'pointer' : 'not-allowed',
                                        paddingRight: '14px',
                                        opacity: showIcons ? 1 : 0.5,
                                    }}
                                    aria-disabled={!showIcons}
                                    onClick={() => {
                                        if (showIcons) {
                                            getPDF(params.row.orderId, params.row.orderType, params.row.billToId);
                                        }
                                    }}
                                    title={showIcons ? localized.DownloadPDF : localized.NoPDFMessage}
                                >
                                    <PDFIcon />
                                </div>
                                {props.shareViaWhatsApp && (
                                    <div
                                        style={{
                                            cursor: showIcons ? 'pointer' : 'not-allowed',
                                            opacity: showIcons ? 1 : 0.5,
                                        }}
                                        aria-disabled={!showIcons}
                                        onClick={() => {
                                            if (showIcons) {
                                                getPDFLink(params.row.orderId, params.row.orderType, params.row.billToId);
                                            }
                                        }}
                                        title={showIcons ? localized.DownloadPDF : localized.NoPDFMessage}
                                    >
                                        <WhatsAppIcon />
                                    </div>
                                )}
                            </div>
                        </strong>
                    )}
                </Stack>
                <Stack direction="row" spacing={2} sx={{ mt: 0.5, justifyContent:'space-between' }} flexWrap="wrap" alignItems="center">
                    <Typography variant="body2">
                        <strong>{props.localized.ItemNumber}:</strong> {row.productSku}
                    </Typography>
                    <Typography variant="body2">
                        <strong>{props.localized.QtyLabel}:</strong> {row.quantity}
                    </Typography>
                </Stack>
                <Stack
                    direction="row"
                    spacing={2}
                    sx={{ mt: 0.5 }}
                    alignItems="center"            
                >
                    
                    <Box
                        sx={{
                            display: 'flex',
                            gap: 2,
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            minWidth: 0,
                            flexGrow: 1,               
                        }}
                    >
                        <Typography variant="body2">
                            <strong>{props.localized.UnitPrice}:</strong>{' '}
                            <Money
                                value={row.unitPrice_Amount}
                                currency={row.price_Currency}
                                country={props.selectedCustomer?.address?.country}
                            />
                        </Typography>
                        <Typography variant="body2">
                            <strong>{props.localized.ProductTotal}:</strong>{' '}
                            <Money
                                value={row.price_Amount}
                                currency={row.price_Currency}
                                country={props.selectedCustomer?.address?.country}
                            />
                        </Typography>
                    </Box>

                    <IconButton
                        size="small"
                        onClick={(e) => { e.stopPropagation?.(); openDrawer(row); }}
                        aria-label={props.localized?.ViewDetails || 'View details'}
                        title={props.localized?.ViewDetails || 'View details'}
                        sx={{ p: 0, color: "black", flexShrink: 0 }}
                    >
                        <ExpandMoreIcon
                            fontSize="small"
                            sx={{
                                p:0,
                                transition: 'transform 200ms ease',
                                transform: isThisRowOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                            }}
                        />
                    </IconButton>

                </Stack>
            </Box>
        );
    };



    const MobileDetailsDrawer = () => {
        const row = selectedRow;
        if (!row) return null;

        const showEstVsShip = () => {
            if (!props.showEstimatedShipDate) return null;

            const isExcluded = (excludeStatuses || []).includes(row.lineStatus);
            const compare = (d1, d2) => DateHelper.compareDates(d1, d2);

            if (!isExcluded) {
                const invalid = compare(row.estimatedDate, row.orderDate) === -1;
                return (
                    <Box>
                        <Typography variant="subtitle2">{props.localized.ShipDate}</Typography>
                        {invalid ? (
                            <Typography variant="body2">NA</Typography>
                        ) : (
                            <DateDisplay date={row.estimatedDate} dateFormat={dateDisplayFormat} />
                        )}
                    </Box>
                );
            } else {
                const invalid = compare(row.shipDate, row.orderDate) === -1;
                return (
                    <Box>
                        <Typography variant="subtitle2">{props.localized.ShipDate}</Typography>
                        {invalid ? (
                            <Typography variant="body2">NA</Typography>
                        ) : (
                            <DateDisplay date={row.shipDate} dateFormat={dateDisplayFormat} />
                        )}
                    </Box>
                );
            }
        };

        return (
            <SwipeableDrawer
                anchor="bottom"
                open={drawerOpen}
                onOpen={() => setDrawerOpen(true)}
                onClose={closeDrawer}
                PaperProps={{
                    sx: { borderTopLeftRadius: 12, borderTopRightRadius: 12, pb: 2 }
                }}

                transitionDuration={280}
                slotProps= {{
                    transition: {
                        timeout: 280
                    },
                }}

            >
            <Fade in={drawerOpen} timeout={{ enter: 250, exit: 250 }} mountOnEnter unmountOnExit>
              <Box sx={{ p: 2 }}>
                <Box
                  sx={{
                    position: 'sticky',
                    top: 0,
                    zIndex: 1,
                    display: 'flex',
                    justifyContent: 'center',
                    bgcolor: 'background.paper',
                    pb: 1
                  }}
                >
                    <IconButton
                        size="small"
                        onClick={closeDrawer}
                        aria-label={props.localized?.CollapseDetails || 'Collapse details'}
                        title={props.localized?.CollapseDetails || 'Collapse details'}
                        sx={{
                            transition: 'transform 120ms ease',
                            '&:active': { transform: 'scale(0.96)' },
                            p:0
                        }}
                    >
                        <ExpandMoreIcon fontSize="small" sx={{ p: 0 }} />
                    </IconButton>
                </Box>
                    <Stack direction="row" alignItems="baseline" justifyContent="space-between">
                        <Typography variant="h6" fontWeight={700}>
                            {props.localized.OrderNumber}: {row.orderId}
                        </Typography>
                        <Chip size="small" label={StatusHelper.formatStatus(row.lineStatus, props.localized)} />
                    </Stack>

                    <Divider sx={{ my: 1.5 }} />
                    <Stack spacing={1.25}>
                        <Box>
                            <Typography variant="h7">{props.localized.ItemNumber}</Typography>
                            <Typography variant="body2">{row.productSku}</Typography>
                        </Box>

                        <Box>
                            <Typography variant="h7">{props.localized.ItemDescription}</Typography>
                            <Typography variant="body2">{row.itemDescription || '-'}</Typography>
                        </Box>

                        <Stack direction="row" spacing={4} flexWrap="wrap">
                            <Box>
                                <Typography variant="h7">{props.localized.QtyLabel}</Typography>
                                <Typography variant="body2">{row.quantity}</Typography>
                            </Box>
                            <Box>
                                <Typography variant="h7">{props.localized.QtyBackOrderedLabel}</Typography>
                                <Typography variant="body2">{row.quantityBackordered ?? 0}</Typography>
                            </Box>
                        </Stack>

                        <Stack direction="row" spacing={4} flexWrap="wrap">
                            <Box>
                                <Typography variant="h7">{props.localized.UnitPrice}</Typography>
                                <Typography variant="body2">
                                    <Money
                                        value={row.unitPrice_Amount}
                                        currency={row.price_Currency}
                                        country={props.selectedCustomer?.address?.country}
                                    />
                                </Typography>
                            </Box>
                            <Box>
                                <Typography variant="h7">{props.localized.ProductTotal}</Typography>
                                <Typography variant="body2">
                                    <Money
                                        value={row.price_Amount}
                                        currency={row.price_Currency}
                                        country={props.selectedCustomer?.address?.country}
                                    />
                                </Typography>
                            </Box>
                        </Stack>

                        <Divider sx={{ my: 1 }} />
                        <Box>
                            <Typography variant="subtitle2">{props.localized.ReferenceNumber}</Typography>
                            <Typography variant="body2">{row.referenceNumber || '-'}</Typography>
                        </Box>

                            <Stack
                                direction="row"
                                sx={{
                                    justifyContent: "space-between"
                                }}
                                flexWrap="wrap" >
                            <Box>
                                <Typography variant="subtitle2">{props.localized.OrderDate}</Typography>
                                <DateDisplay date={row.orderDate} dateFormat={dateDisplayFormat} />
                            </Box>
                            <Box>
                                <Typography variant="subtitle2">{props.localized.RequestDate}</Typography>
                                <DateDisplay date={row.requestDate} dateFormat={dateDisplayFormat} />
                            </Box>
                            {showEstVsShip()}
                        </Stack>

                        <Box>
                            <Typography variant="h7">{props.localized.InvoiceNumber}</Typography>
                            <Typography variant="body2">{row.invoiceNumber || '-'}</Typography>
                        </Box>
                        {row.orderCompany && (
                            <Stack direction="row" spacing={4} flexWrap="wrap">
                                <Box>
                                    <Typography variant="h7">{props.localized.Company || 'Company'}</Typography>
                                    <Typography variant="body2">{row.orderCompany}</Typography>
                                </Box>
                                <Box>
                                    <Typography variant="h7">{props.localized.Type || 'Type'}</Typography>
                                    <Typography variant="body2">{row.orderType}</Typography>
                                </Box>
                            </Stack>
                        )}
                        <Stack direction="row" spacing={1} sx={{ pt: 1 }}>
                            {props.ordersByLinePDF && (
                                <Button
                                    variant="outlined"
                                    size="small"
                                    startIcon={<PDFIcon />}
                                    onClick={() => getPDF(row.orderId, row.orderType, row.billToId)}
                                >
                                    {props.localized.DownloadPDF}
                                </Button>
                            )}
                            {props.shareViaWhatsApp && (
                                <Button
                                    variant="outlined"
                                    size="small"
                                    startIcon={<WhatsAppIcon />}
                                    onClick={() => getPDFLink(row.orderId, row.orderType, row.billToId)}
                                >
                                    {props.localized.ShareViaWhatsApp || 'Share via WhatsApp'}
                                </Button>
                            )}
                        </Stack>
                    </Stack>
                    </Box>
                </Fade>
            </SwipeableDrawer>
        );
    };

    const listViewColDef = {
        field: 'listColumn',
        headerName: props.localized.OrderNumber,
        flex: 1,
        sortable: false,
        disableColumnMenu: true,
        renderCell: listViewCell,
        disableExport: true
    };


    const columns = [
        {
            field: 'orderId',
            headerName: props.localized.OrderNumber,
            headerAlign: 'left',
            renderCell: (params) => {
                return (
                    <Link to={`/order/${params.row.orderId}/${params.row.orderCompany}/${params.row.orderType}`}>
                        {params.row.orderId}
                    </Link>
                )
            }
        },
        {
            field: 'referenceNumber',
            headerName: props.localized.ReferenceNumber,
            headerAlign: 'left',
        },
        {
            field: 'orderDate',
            headerName: props.localized.OrderDate,
            headerAlign: 'left',
            renderCell: (params) => {
                return (
                    <DateDisplay date={params.row.orderDate} dateFormat={dateDisplayFormat} />
                )
            }
        },
        {
            field: 'requestDate',
            headerName: props.localized.RequestDate,
            headerAlign: 'left',
            renderCell: (params) => {
                return (
                    <DateDisplay date={params.row.requestDate} dateFormat={dateDisplayFormat} />
                )
            }

        },
        {
            field: 'estimatedDate',
            headerName: props.localized.ShipDate,
            headerAlign: 'left',
            renderCell: (params) => {
                return (
                    props.showEstimatedShipDate &&
                    <>
                        {!excludeStatuses.includes(params.row.lineStatus) 
                            ? <>
                                {(DateHelper.compareDates(params.row.estimatedDate, params.row.orderDate) === -1)
                                    ? <div>NA</div>
                                    : <DateDisplay date={params.row.estimatedDate} dateFormat={dateDisplayFormat} />
                                }
                            </>
                            : <>
                                {(DateHelper.compareDates(params.row.shipDate, params.row.orderDate) === -1)
                                    ? <div>NA</div>
                                    : <DateDisplay date={params.row.shipDate} dateFormat={dateDisplayFormat} />
                                }
                            </>
                        }
                    </>
                )
            }
        },
        {
            field: 'productSku',
            headerName: props.localized.ItemNumber,
            headerAlign: 'left',
        },
        {
            field: 'itemDescription',
            headerName: props.localized.ItemDescription,
            headerAlign: 'left',
            flex: 1
        },
        {
            field: 'quantity',
            headerName: props.localized.QtyLabel,
            headerAlign: 'left',
        },
        {
            field: 'quantityBackordered',
            headerName: props.localized.QtyBackOrderedLabel,
            headerAlign: 'left',
        },
        {
            field: 'unitPrice_Amount',
            headerName: props.localized.UnitPrice,
            headerAlign: 'right',
            align: 'right',
            renderCell: (params) => {
                return (
                    <Money value={params.row.unitPrice_Amount} currency={params.row.price_Currency}  country={props.selectedCustomer.address.country} />
                )
            }
        },
        {
            field: 'price_Amount',
            headerName: props.localized.ProductTotal,
            headerAlign: 'right',
            align: 'right',
            renderCell: (params) => {
                return (
                    <Money value={params.row.price_Amount} currency={params.row.price_Currency} country={props.selectedCustomer.address.country} />
                )
            }
        },
        {
            field: 'lineStatus',
            headerName: props.localized.Status,
            headerAlign: 'left',
            renderCell: (params) => {
                return (
                    <div >{StatusHelper.formatStatus(params.row.lineStatus, props.localized)}</div>
                )
            }
        },
        {
            field: 'invoiceNumber',
            headerName: props.localized.InvoiceNumber,
            headerAlign: 'left'
        },
        {
            field: 'openLines',
            headerName: "PDF",
            headerAlign: 'left',
            renderCell: (params) => {
                const fileData = fileExistenceData.find(file => String(file.fileNumber).trim() == String(params.row.orderId).trim() && file.exists == true);
                const showIcons = fileData ? fileData.exists : false;
                return (
                    props.ordersByLinePDF && (
                    <strong>
                        <div className="br-invoice-pdf d-inline-flex" style={{ fontSize: '18px' }}>
                    <div
                        style={{
                            cursor: showIcons ? 'pointer' : 'not-allowed',
                            paddingRight: '14px',
                            opacity: showIcons ? 1 : 0.5,
                        }}
                        aria-disabled={!showIcons}
                        onClick={() => {
                            if (showIcons) {
                                getPDF(params.row.orderId, params.row.orderType, params.row.billToId);
                            }
                        }}
                        title={showIcons ? localized.DownloadPDF : localized.NoPDFMessage}
                    >
                        <PDFIcon />
                                </div>
                                {props.shareViaWhatsApp && (
                                    <div
                                        style={{
                                            cursor: showIcons ? 'pointer' : 'not-allowed',
                                            opacity: showIcons ? 1 : 0.5,
                                        }}
                                        aria-disabled={!showIcons}
                                        onClick={() => {
                                            if (showIcons) {
                                                getPDFLink(params.row.orderId, params.row.orderType, params.row.billToId);
                                            }
                                        }}
                                        title={showIcons ? localized.DownloadPDF : localized.NoPDFMessage}
                                    >
                                        <WhatsAppIcon />
                                    </div>
                                )}</div>
                    </strong>
                    )
                )
            },
            disableClickEventBubbling: true
        }
    ];
    return (
        <>
          {
          (gridLocalized && Object.keys(gridLocalized).length > 0) &&
                <>
                    <ThemeProvider theme={wrapperTheme}>
                        <Paper sx={{
                            height: 700,
                            width: '100%'
                        }}>
                            <TranslatableDataGridServerLoaded
                                columnVisibilityModel={!props.ordersByLinePDF ? { openLines: false } : {}}
                                rows={orderRows}
                                columns={columns}
                                count={props.count}
                                toolbar={customToolbar}
                                loading={props.fetching}
                                fetching={props.fetching}
                                labels={gridLocalized}
                                square={true}
                                paginationModel={props.paginationModel}
                                setPaginationModel={props.setPaginationModel}
                                listView={props.listView }
                                listViewColumn={listViewColDef}
                                visibileFields={visibleFields}
                                getRowHeight={props.listView ? () => 'auto' : undefined}
                                getEstimatedRowHeight={props.listView ? () => 180 : undefined}

                            />

                            {props.listView && <MobileDetailsDrawer />}

                        </Paper>
                    </ThemeProvider>
                </>
          }
        </>
    );
};

export default OrderLines;
